import { observer } from 'mobx-react-lite';

import { useChangeCellState } from './changed-cells-provider';
import { DataGridTariffRow } from './create-table-grid-data';
import { useCellEditor } from './edit-cell-provider';

// import { TariffProfileRulesRecord } from './types';

type GridCellComponentProps = {
  row: DataGridTariffRow;
  zoneId: number;
  className?: string;
};

export const GridCellComponent = observer(
  ({ row, zoneId, ...props }: GridCellComponentProps) => {
    const cellEditor = useCellEditor();
    const changeCellState = useChangeCellState();

    const ids = {
      zoneId,
      terminalTypeId: row?.terminalTypeId,
      tariffTypeId: row?.tariffTypeId,
    };

    const handleEditTariffCell = () => {
      if (!row) return;

      cellEditor.showCellEditor(ids);
    };

    const isChangedCell = row ? changeCellState.getCellStatus(ids) : false;

    return (
      <td
        {...props}
        style={{ background: isChangedCell ? '#fff3cb' : '' }}
        onClick={handleEditTariffCell}
      />
    );
  },
);
